<template>
  <div>
    <el-card>
      <el-row>
        <el-col :span="7">
          <el-date-picker
            v-model="starttime"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
          <el-button
            type="goon"
            style="margin-left: 20px"
            @click="GetPeopleDayPeport"
            >查询</el-button
          >
          <el-button type="goon" style="margin-left: 20px" @click="onClickOpen"
            >导出</el-button
          >
        </el-col>
        <!-- <el-col :span="4"> </el-col> -->
      </el-row>
    </el-card>
    <div class="tui-tableTitle">折合人日数表</div>
    <el-card>
      <table class="dataintable">
        <tr>
          <th colspan="1" rowspan="2">年龄组</th>
          <th colspan="3">托班（1岁以上）</th>
          <th colspan="3">托班（2岁以上）</th>
          <th colspan="3">小班（3岁以上）</th>
          <th colspan="3">中班（4岁以上）</th>
          <th colspan="3">大班（5岁以上）</th>
        </tr>
        <tr>
          <td>早点</td>
          <td>午餐</td>
          <td>午点</td>

          <td>早点</td>
          <td>午餐</td>
          <td>午点</td>

          <td>早点</td>
          <td>午餐</td>
          <td>午点</td>

          <td>早点</td>
          <td>午餐</td>
          <td>午点</td>

          <td>早点</td>
          <td>午餐</td>
          <td>午点</td>
        </tr>
        <tr>
          <td><i>人数</i></td>
          <td v-for="(item, index) in New_PeopleDayInfos.Row1" :key="index">
            {{ item }}
          </td>
        </tr>
        <tr>
          <td><i>热量分配</i></td>
          <td v-for="(item, index) in New_PeopleDayInfos.Row2" :key="index">
            {{ item }}
          </td>
        </tr>
        <tr>
          <td>折合人日数</td>
          <td v-for="(item, index) in New_PeopleDayInfos.Row3" :key="index">
            {{ item }}
          </td>
        </tr>
        <tr>
          <td><i>年龄组人日数</i></td>
          <td
            colspan="3"
            v-for="(item, index) in New_PeopleDayInfos.Row4"
            :key="index"
          >
            {{ item }}
          </td>
        </tr>
        <tr>
          <td><i>总人日数</i></td>

          <td
            colspan="15"
            v-for="(item, index) in New_PeopleDayInfos.Row5"
            :key="index"
          >
            {{ item }}
          </td>
        </tr>
      </table>
    </el-card>
    <div class="tui-tableTitle">营养素平均供给量计算表</div>
    <el-card>
      <el-table
        :data="NutrientAverageInfos"
        style="width: 100%"
        :header-cell-style="{
          background: '#F2F5FF',
          color: '#333',
          'text-align': 'center',
        }"
        border
      >
        <el-table-column label="年龄" prop="Ages" align="center">
        </el-table-column>
        <el-table-column label="人日数" prop="PeopleDays" align="center">
        </el-table-column>
        <el-table-column label="热量">
          <el-table-column
            label="差值"
            prop="Energy1"
            align="center"
          ></el-table-column>
          <el-table-column
            label="共差"
            prop="Energy2"
            align="center"
          ></el-table-column>
        </el-table-column>
        <el-table-column label="蛋白质">
          <el-table-column
            label="差值"
            prop="Protein1"
            align="center"
          ></el-table-column>
          <el-table-column
            label="共差"
            prop="Protein2"
            align="center"
          ></el-table-column>
        </el-table-column>
        <el-table-column label="钙mg/d">
          <el-table-column
            label="差值"
            prop="Calcium1"
            align="center"
          ></el-table-column>
          <el-table-column
            label="共差"
            prop="Calcium2"
            align="center"
          ></el-table-column>
        </el-table-column>
        <el-table-column label="铁mg/d">
          <el-table-column
            label="差值"
            prop="Iron1"
            align="center"
          ></el-table-column>
          <el-table-column
            label="共差"
            prop="Iron2"
            align="center"
          ></el-table-column>
        </el-table-column>
        <el-table-column label="锌mg/d">
          <el-table-column
            label="差值"
            prop="Zinc1"
            align="center"
          ></el-table-column>
          <el-table-column
            label="共差"
            prop="Zinc2"
            align="center"
          ></el-table-column>
        </el-table-column>
        <el-table-column label="维生素Aμg/d">
          <el-table-column
            label="差值"
            prop="VitaminA1"
            align="center"
          ></el-table-column>
          <el-table-column
            label="共差"
            prop="VitaminA2"
            align="center"
          ></el-table-column>
        </el-table-column>
        <el-table-column label="维生素B1mg/d">
          <el-table-column
            label="差值"
            prop="VitaminB11"
            align="center"
          ></el-table-column>
          <el-table-column
            label="共差"
            prop="VitaminB12"
            align="center"
          ></el-table-column>
        </el-table-column>
        <el-table-column label="维生素B2mg/d">
          <el-table-column label="差值" prop="VitaminB21"></el-table-column>
          <el-table-column label="共差" prop="VitaminB22"></el-table-column>
        </el-table-column>
        <el-table-column label="维生素Cmg/d">
          <el-table-column label="差值" prop="VitaminC1"></el-table-column>
          <el-table-column label="共差" prop="VitaminC2"></el-table-column>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>
<script>
import { GetPeopleDayPeport } from "../../../api/api";
import {
  getMonthStartDate,
  getMonthEndDate,
} from "../../../../util/otherRenders";

export default {
  data() {
    return {
      tableData: [],
      PageSize: 10,
      PageIndex: 1,
      total: 0,
      userInfo: {},
      starttime: [],
      New_PeopleDayInfos: {},
      NutrientAverageInfos: [],
    };
  },
  async created() {
    this.userInfo = JSON.parse(window.localStorage.user);
    await this.getNowTime();
    await this.GetPeopleDayPeport();
  },
  methods: {
    // 导出
    async onClickOpen() {
      window.open(
        `http://apiv3.mushroomisland.cn/api/mgd/He_FoodReportTableControlle/Export_GetPeopleDayPeport?SchoolId=${this.userInfo.SchoolId}&StartDate=${this.starttime[0]}&EndDate=${this.starttime[1]}`,
        "_brank"
      );
    },
    async GetPeopleDayPeport() {
      const params = {
        SchoolId: this.userInfo.SchoolId,
        StartDate: this.starttime[0],
        EndDate: this.starttime[1],
      };
      let res = await GetPeopleDayPeport(params);
      if (res.data.success) {
        this.New_PeopleDayInfos = res.data.response.New_PeopleDayInfos;
        this.NutrientAverageInfos = res.data.response.NutrientAverageInfos;
      } else {
        this.New_PeopleDayInfos = {};
        this.NutrientAverageInfos = [];
      }
    },
    async getNowTime() {
      this.starttime.push(getMonthStartDate());
      this.starttime.push(getMonthEndDate());
      // conosle.log(this.starttime)
    },
  },
};
</script>
<style lang="less" scoped>
table.dataintable {
  margin-top: 15px;
  border-collapse: collapse;
  border: 1px solid #ebeef5;
  width: 100%;
}
table.dataintable th {
  // vertical-align: baseline;
  padding: 5px 15px 5px 6px;
  // background-color: #3f3f3f;
  background: "#F2F5FF";
  color: "#333";
  border: 1px solid #ebeef5;
  text-align: center;
  font-size: 14px;
}
table.dataintable td {
  // vertical-align: text-top;
  padding: 6px 6px 6px 6px;
  border: 1px solid #ebeef5;
  text-align: center;
  font-size: 14px;
  font-style: normal;
}
table.dataintable tr:nth-child(1) {
  background-color: #f2f5ff;
}
table.dataintable tr:nth-child(even) {
  background-color: #fff;
}
.el-button--goon {
  color: #fff;
  background-color: #5474e6;
  border-color: #5474e6;
  height: 34px;
  line-height: 34px;
  padding: 0 20px;
}
.tui-tableTitle {
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #666666;
  padding: 20px 0;
}
</style>